export default {
  additionalInfo: 'معلومات إضافية',
  qualification: 'المؤهل العلمي',
  rank: 'رتبة الممارس الصحي',
  schsRegistrationNumber: 'رقم تسجيل الهيئة السعودية للتخصصات الصحية',
  registrationNumber: 'رقم التسجيل',
  schsExpiryDate: 'تاريخ انتهاء تسجيل الهيئة السعودية للتخصصات الصحية',
  expiryDate: 'تاريخ الانتهاء',
  additionalContact: 'معلومات الاتصال الإضافية (اختياري)',
  placeOfPractice: 'مكان العمل',
  acceptAll: 'أوافق على كل ما يلي:',
  payNow: 'ادفع الآن',
  quoteTimer: 'سينقضي وقت التسعيرة خلال',
  // Form Fields
  policyHolderMobile: 'رقم جوال حامل الوثيقة',
  policyHolderEmail: 'البريد الإلكتروني لحامل الوثيقة',
  additionalMobileNumber: 'أدخل رقم الجوال الإضافي',
  governmentPractice: 'حكومي #1',
  otpMessage: 'سيتم إرسال كود تأكيد عملية الشراء على جوال حامل الوثيقة',
  iban: 'رقم الآيبان',
  ibanLabel:
    'نحن بحاجة إلى رقم الآيبان الخاص بك لجعل المدفوعات والمطالبات أكثر أمانًا',
  addIban: 'أضف آيبان',
  noIbansFound: 'لا يوجد رقم آيبان متاح',
  startsWithSA: 'يبدأ بSA',
  includesBankIdentifierCode: 'يحتوى على كود تعريف البنك',
  ibanTotalNumber: 'اجمالى 22 رقم',
  ibanDrawerTitle: 'الرجاء إدخال رقم الآيبان الخاص بك',
  ibanDrawerSubtitle:
    'نحن بحاجة إلى رقم الآيبان الخاص بك لجعل المدفوعات والمطالبات أكثر أمانًا',
  ibanAddedSuccessfully: 'تم إضافة رقم الآيبان بنجاح',
  tabs: {
    overview: 'نظرة عامة',
    coverage: 'التغطية',
    benefits: 'المزايا',
    policyholderDetails: 'تفاصيل حامل الوثيقة',
    professionInfo: 'معلومات المهنة',
    declarations: 'التصريحات',
    policyInfo: 'معلومات الوثيقة',
  },

  overview: {
    policyLimit: 'حد الوثيقة',
    deductible: 'مبلغ التحمل',
    noDeductible: 'لا يوجد مبلغ تحمل',
  },

  coverage: {
    policyLimit: 'حد الوثيقة',
    deductible: 'الخصومات',
    coverageDetails: 'تفاصيل التغطية',
    coveragePeriod: 'فترة التغطية',
    effectiveDate: 'تاريخ السريان',
    features: 'المزايا',
    retroactiveCover: 'التغطية بأثر رجعي',
    extendedReportingPeriod: 'تمديد مدة التبليغ عن المطالبات',
    noRetroactiveCover: 'لا توجد خيارات للتغطية بأثر رجعي',
    noExtendedReportingPeriod: 'لا توجد خيارات لتمديد مدة التبليغ',
  },

  benefits: {
    includedBenefits: 'المزايا المشمولة',
    additionalBenefits: 'المزايا الإضافية',
    medicalMalpracticeCoverage: 'تغطية الأخطاء الطبية',
    legalDefense: 'الدفاع القانوني',
    settlementCosts: 'تكاليف التسوية',
    courtAttendance: 'الحضور في المحكمة',
    retroactiveCoverage: 'التغطية بأثر رجعي',
    extendedReporting: 'تمديد مدة التبليغ',
    noRetroactiveCoverage: 'لا توجد تغطية بأثر رجعي',
    noExtendedReporting: 'لا توجد فترة تمديد التبليغ',
  },

  policyInfo: {
    policyEffectiveDate: 'تاريخ بدء الوثيقة',
  },

  // Policyholder Details Section
  viewAll: 'عرض الكل',
  performingSurgeries: 'إجراء العمليات الجراحية',
  experience: 'الخبرة',
  specialty: 'التخصص',
  nationalId: 'الهوية الوطنية',
  iqamaNumber: 'رقم الإقامة',
  personalAndProfessionalDetails: 'التفاصيل الشخصية والمهنية',
  personalDetails: 'التفاصيل الشخصية',
  professionalDetails: 'التفاصيل المهنية',
  policyholderDetails: {
    idNumber: 'رقم الهوية',
    name: 'الاسم',
    dob: 'تاريخ الميلاد',
    nationality: 'الجنسية',
    borderNumber: 'رقم الحدود',
    sponsorNumber: 'رقم المنشأة',
    idSponsorNumber: 'الهوية الوطنية/ رقم الإقامة',
  },
  professionInfo: {
    speciality: 'التخصص الطبي',
    subSpeciality: 'فرع التخصص الطبي',
    surgeryQuestion:
      'هل تقوم بعمل عمليات جراحية أو تشارك في العمليات الجراحية؟',
    yearsOfExperience: 'سنوات الخبرة',
    regionOfPractice: 'منطقة ممارسة العمل',
    placeOfPractice: 'مكان العمل',
  },
  declarations: {
    previousPolicy: {
      title: 'تفاصيل البوليصة السابقة',
      policyNumber: 'رقم البوليصة',
      insuranceCompany: 'شركة التأمين',
      expirationDate: 'تاريخ الإنتهاء',
      uninterruptedDuration: 'مدة غير منقطعة',
      effectiveDate: 'تاريخ السريان',
      retroactiveDate: 'تاريخ بأثر رجعي',
    },
    disclaimer:
      'أقر بموجب هذا الطلب حسب أقصى علمي واعتقادي أن الاجابات والبيانات الواردة في هذا الطلب كاملة وصحيحة وأنني لم أحرف أو أكتم أية حقيقة جوهرية.\n\n (الحقيقة الجوهرية هي تلك التي يحتمل أن تؤثر في قرار <bold>{{insuranceCompany}}</bold> بقبول أو تقييم هذا الطلب، وإذا كان هناك شك في أن حقيقة ما هي جوهرية فيجب عندها الإفصاح عنها).\n\n               أقر بأنني اطلعت ووافقت على وثيقة تأمين أخطاء ممارسة المهن الطبية للأفراد.\n\n  إن تقديم هذا الطلب  يلزم طالب التأمين بالتعاقد على التأمين، كما يلزم <bold>{{insuranceCompany}}</bold> بقبوله، ولكن من المتفق عليه أن هذا الطلب سيعتبر أساسا للتعاقد إذا ما تم إصدار الوثيقة.',
    paymentAuthorization:
      'أفوض <bold>{{insuranceCompany}}</bold> و تأميني بقيد مبلغ {{paidAmount}} ريال سعودي ، والذي يمثل قيمة الإشتراك وذلك على قناة الدفع المختارة.',
    termsAndConditions: 'رجاء قراءة و قبول الشروط و الأحكام للإستمرار',
    termsAndConditionsLink: 'الشروط و الأحكام',
    addressVerificationError:
      'لم نتمكن من التحقق من العنوان الوطني للهوية المدخلة، يرجى التأكد من وجود عنوان وطني صالح قبل الإستمرار',
  },
  summaryDetails: {
    details: 'التفاصيل',
    priceBreakdown: 'تفصيل السعر',
    policyValue: 'قيمة الوثيقة',
    extendedReportingBenefit: 'منفعة تمديد مدة التبليغ عن المطالبات',
    retroactiveCoverage: 'التغطية بأثر رجعي',
    adminFees: 'مصاريف إدارية (غير مستردة في حال الإلغاء)',
    subtotal: 'المجموع الجزئي',
    vat: 'ضريبة القيمة المضافة',
    totalAmount: 'المبلغ الإجمالي',
    includesVat: 'شامل الضريبة المضافة',
    close: 'إغلاق',
    tamaraHintTitle: 'قسم فاتورتك على {{numberOfInstallments}} دفعات',
    tamaraHintDescription:
      'اشتر الوثيقة الآن و قسم فاتورتك على {{numberOfInstallments}} دفعات و استفد من الباقة الذكية',
    tabbyHintTitle: 'قسم فاتورتك على {{numberOfInstallments}} دفعات',
    tabbyHintDescription:
      'اشتر الوثيقة الآن و قسم فاتورتك على {{numberOfInstallments}} دفعات و استفد من الباقة الذكية',
    schemeDiscount: 'خصم البرنامج',
  },
  coupons: {
    availableCoupons: 'الخصومات المتاحة',
    couponsDescription: 'يمكن تطبيق الخصومات عند الدفع',
    readMore: 'اقرأ المزيد',
    copyCode: 'نسخ الكود',
    copied: 'تم النسخ!',
    discount: 'خصم',
  },
  pointsRedemption: {
    useMyAvailablePoints: 'استخدم نقاطي المتاحة',
    surplusPoints: 'النقاط الفائضة',
    referralPoints: 'نقاط الإحالة',
    totalRedemption: 'إجمالي الاسترداد',
    availablePoints: 'النقاط المتاحة',
    redeemedAmount: 'المبلغ المسترد',
    disclaimer: 'استرداد النقاط غير قابل للاسترداد، خاضع لـ',
    termsAndConditions: 'الشروط والأحكام',
    sliderPlaceholder: 'سيتم تنفيذ مكون الشريط المنزلق عند نشر SliderInput',
    redemptionHint:
      'يمكنك استبدال ما يصل إلى {{maxRedemptionAmount}} ريال سعودي لهذه العملية. ويجب دفع حد أدنى قدره {{minAmount}} ريال سعودي',
  },
  nationalAddressPopup: {
    // Title
    titleRequired: 'العنوان الوطني مطلوب',
    // Banners
    bannerNonExistence:
      'تعذر العثور على عنوانك الوطني. يرجى رفع شهادة العنوان الوطني للمتابعة.',
    // Upload
    uploadLabel: 'رفع شهادة العنوان الوطني',
    uploadDropzone: 'اسحب الملف أو اضغط للرفع',
    uploadRules: 'JPG، JPEG، PNG، PDF · الحد الأقصى 15 ميجابايت · مطلوب',
    uploadHint: 'يرجى إدخال بيانات العنوان كما هي مذكورة في الشهادة تماماً.',
    exampleTooltip: 'مثال على شهادة العنوان الوطني',
    // Fields
    city: 'المدينة',
    district: 'الحى',
    street: 'الشارع',
    buildingNumber: 'رقم المبنى',
    zipCode: 'الرقم البريدى',
    additionalNumber: 'رقم اضافي',
    // Buttons
    cancel: 'إلغاء',
    saveContinue: 'حفظ والمتابعة للدفع',
    // Save confirmation
    saveConfirmation: 'هل أنت متأكد من حفظ البيانات؟',
    saveSuccess: 'تم حفظ البيانات بنجاح',
    // Shared with MissingAddressDataPopup
    confirm: 'حفظ والمتابعة للدفع',
  },
  otpPopup: {
    resend: 'إعادة ارسال',
    countdownText: 'سينتهي خلال',
    expiryText: 'انتهت صلاحية الرمز',
    incorrectOtpMessage: 'الرمز غير صحيح',
  },
  requiredInformation: {
    title: 'المعلومات المطلوبة',
    description: 'يرجى تزويدنا بالمعلومات الناقصة أدناه',
  },
} as const
